import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Firebase configuration from environment variables
// Defaults to demo values if not provided
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCBFhX0gdfHyRlb-4GSUx102En1PE36Qo4',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'demoportal.icentrewa.com',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'icentrewa-demo-id',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'icentrewa-demo-id.appspot.com',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '717603775926',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:30836452604:android:47b80f0ee9a9eff92ebb79',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-EZSJDKHK9R',
}

const firebase = initializeApp(firebaseConfig)
//const analytics = getAnalytics(firebase);

// const firebase = initializeApp({
//     apiKey: "AIzaSyB1lUWKp45Ofny_jHXtjajqFsOxU7bkfz4",
//     authDomain: "maclocal-project-id.firebaseapp.com",
//     projectId: "maclocal-project-id",
//     storageBucket: "maclocal-project-id.appspot.com",
//     messagingSenderId: "427816391467",
//     appId: "1:427816391467:web:9a72e46b0a015219e26b6e"
// })
export const auth = getAuth(firebase)
